export default __webpack_public_path__ + "49e55024cdf62550588e8e8a668f62db.svg";